<i class="fas fa-spinner" [ngClass]="{'fa-5x': size == 'large', 'fa-spin': type == 'spin', 'fa-pulse': type == 'pulse', 'fa-2x': size == 'medium'}"></i>